function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useMemo } from 'react';
import cn from 'classnames';
import { Column, TextButton, Typography } from 'seagull';
import { PlusCircleLine } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { legalTermsModel } from "../../../../models";
import { LegalTermsDropdown } from "../../../LegalTermsDropdown/LegalTermsDropdown";
import { ExplicitApproval } from "./ExplicitApproval/ExplicitApproval";
import styles from "./LegalTerms.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const GetLegalTermsTID = prefixTestId => getTestIds(prefixTestId);
export const LegalTerms = _ref => {
  let {
    agreementLegalTerms,
    withTitle = true,
    onAgreementLegalTermsChange,
    isReadOnly,
    testId,
    errors,
    withExplicitApproval,
    editContext,
    sourceId,
    resetLocalContentKey
  } = _ref;
  const mappedAgreementLegalTerms = useMemo(() => {
    if (agreementLegalTerms.length === 0) {
      return [];
    }
    return legalTermsModel.fromRelationshipLegalTerms(agreementLegalTerms.filter(legalTerm => !!legalTerm));
  }, [agreementLegalTerms]);
  const {
    LegalTermsTID
  } = useMemo(() => GetLegalTermsTID(testId), [testId]);
  const onLegalTermsChange = (legalTerms, index) => {
    const updatedAgreementLegalTerms = [...agreementLegalTerms];
    updatedAgreementLegalTerms[index] = legalTerms ? legalTermsModel.toRelationshipLegalTermsDocuments(legalTerms) : null;
    onAgreementLegalTermsChange(updatedAgreementLegalTerms);
  };
  const onAddAdditionalTermsOfService = () => {
    onAgreementLegalTermsChange([...agreementLegalTerms, null]);
  };
  const isMaxLegalTermsReached = (agreementLegalTerms === null || agreementLegalTerms === void 0 ? void 0 : agreementLegalTerms.length) >= 4;
  const onLocalContentSave = (legalTermId, content) => {
    const index = agreementLegalTerms.findIndex(lt => (lt === null || lt === void 0 ? void 0 : lt.legalTermsId) === legalTermId);
    if (index === -1) return;
    const legalTerm = agreementLegalTerms[index];
    if (!legalTerm || legalTerm.type !== 'quill') return;
    const updatedAgreementLegalTerms = [...agreementLegalTerms];
    updatedAgreementLegalTerms[index] = _objectSpread(_objectSpread({}, legalTerm), {}, {
      contentOverride: content.value ? {
        type: 'custom',
        custom: {
          content: JSON.stringify(content.value)
        }
      } : {
        type: 'none'
      }
    });
    onAgreementLegalTermsChange(updatedAgreementLegalTerms);
  };
  const onRemoveLegalTerm = index => {
    const updatedAgreementLegalTerms = agreementLegalTerms.filter((_, i) => i !== index);
    onAgreementLegalTermsChange(updatedAgreementLegalTerms);
  };
  const _onTermsOfServiceChange = (index, termsOfService) => {
    const legalTerm = agreementLegalTerms[index];
    if (!legalTerm) return;
    const updatedAgreementLegalTerms = [...agreementLegalTerms];
    updatedAgreementLegalTerms[index] = _objectSpread(_objectSpread({}, legalTerm), {}, {
      termsOfService
    });
    onAgreementLegalTermsChange(updatedAgreementLegalTerms);
  };
  return /*#__PURE__*/_jsxs(Column, {
    gap: 16,
    children: [agreementLegalTerms.length > 1 && withTitle && /*#__PURE__*/_jsx(Typography, {
      variant: "h6",
      testId: LegalTermsTID.Title(),
      children: "Terms of Service"
    }), agreementLegalTerms.map((legalTerm, index) => {
      var _errors$index, _errors$index2;
      return /*#__PURE__*/_jsxs(Column, {
        gap: 16,
        className: cn(styles.legalTermDropdown, {
          [styles.withCard]: agreementLegalTerms.length > 1 && withExplicitApproval
        }),
        children: [/*#__PURE__*/_jsx(LegalTermsDropdown, {
          entityLegalTerms: mappedAgreementLegalTerms,
          onSelectLegalTerm: updatedLegalTerm => {
            onLegalTermsChange(updatedLegalTerm, index);
          },
          error: errors === null || errors === void 0 || (_errors$index = errors[index]) === null || _errors$index === void 0 ? void 0 : _errors$index.legalTermField,
          selectedLegalTermId: legalTerm === null || legalTerm === void 0 ? void 0 : legalTerm.legalTermsId,
          disabledItems: agreementLegalTerms.filter(term => term !== null && term.legalTermsId !== (legalTerm === null || legalTerm === void 0 ? void 0 : legalTerm.legalTermsId)).map(term => ({
            id: term.legalTermsId,
            tooltip: 'This document is already included in this proposal'
          })),
          disabled: isReadOnly,
          testId: LegalTermsTID.LegalTermDropdown(index),
          onRemoveDropdown: index > 0 ? () => onRemoveLegalTerm(index) : undefined,
          editContext: editContext,
          sourceId: sourceId,
          onLocalSave: editContext ? onLocalContentSave : undefined,
          resetLocalContentKey: resetLocalContentKey
        }), withExplicitApproval && /*#__PURE__*/_jsx(ExplicitApproval, {
          testId: LegalTermsTID.ExplicitApproval(index),
          termsOfService: legalTerm === null || legalTerm === void 0 ? void 0 : legalTerm.termsOfService,
          onTermsOfServiceChange: termsOfService => _onTermsOfServiceChange(index, termsOfService),
          disabled: isReadOnly,
          error: errors === null || errors === void 0 || (_errors$index2 = errors[index]) === null || _errors$index2 === void 0 ? void 0 : _errors$index2.explicitApproval
        })]
      }, index);
    }), !isMaxLegalTermsReached && !isReadOnly && /*#__PURE__*/_jsx(TextButton, {
      testId: LegalTermsTID.AddAdditionalTermsOfService(),
      onClick: onAddAdditionalTermsOfService,
      underline: "none",
      className: styles.addAdditionalTermsOfService,
      prefixIcon: /*#__PURE__*/_jsx(PlusCircleLine, {}),
      children: "Add additional Terms of Service"
    })]
  });
};